import { resolveUrl } from "~/utils/url/urlResolver";
import { getCsrfValue } from "~/common/utils/ApiHelper";

const downloadCadUrl = "/cad/downloadCadUrl";

interface DownloadUrlParams {
  selectionPath: string;
  partId: string;
  cadFormatId: number;
}

export async function fetchCadDownloadUrl(data: DownloadUrlParams): Promise<string> {
  const response = await fetch(resolveUrl(downloadCadUrl), {
    body: JSON.stringify(data),
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "POST",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });
  return await response.json();
}
